import React, { useState, useEffect } from "react";
import "./Question.css";
import { useLocalization } from "../../../context/LocalizationContext";
import { convertToArabicNumerals } from "../../../utils/helpers";

const Question = ({
  question,
  questionIndex,
  totalQuestions,
  onAnswer,
  currentAnswer,
}) => {
  const { isRTL, t } = useLocalization();
  const [selectedOptions, setSelectedOptions] = useState(() => {
    if (question.question_type === "MULTI_SELECT") {
      return Array.isArray(currentAnswer) ? currentAnswer : [];
    }
    return currentAnswer || null;
  });

  useEffect(() => {
    if (question.question_type === "MULTI_SELECT") {
      setSelectedOptions(Array.isArray(currentAnswer) ? currentAnswer : []);
    } else {
      setSelectedOptions(currentAnswer || null);
    }
  }, [currentAnswer, question.question_type]);

  const handleOptionClick = (option) => {
    let newSelection;

    if (question.question_type === "SINGLE_CHOICE") {
      newSelection = option.id;
    } else if (question.question_type === "MULTI_SELECT") {
      const currentOptions = Array.isArray(selectedOptions)
        ? selectedOptions
        : [];

      const isNoneOption =
        option.displayText.toLowerCase().includes("none") ||
        option.displayText.toLowerCase().includes("other") ||
        option.displayText.toLowerCase().includes("لا شيء") ||
        option.displayText.toLowerCase().includes("أخرى");

      if (isNoneOption) {
        newSelection = currentOptions.includes(option.id)
          ? currentOptions.filter((id) => id !== option.id)
          : [option.id];
      } else {
        // Find any none/other option that might be selected
        const noneOption = question.options.find((opt) => {
          const text = opt.displayText.toLowerCase();
          return (
            text.includes("none") ||
            text.includes("other") ||
            text.includes("لا شيء") ||
            text.includes("أخرى")
          );
        });

        let filteredOptions = currentOptions;
        if (noneOption && currentOptions.includes(noneOption.id)) {
          filteredOptions = currentOptions.filter((id) => id !== noneOption.id);
        }

        newSelection = filteredOptions.includes(option.id)
          ? filteredOptions.filter((id) => id !== option.id)
          : [...filteredOptions, option.id];
      }
    }

    setSelectedOptions(newSelection);
    onAnswer(question.id, newSelection);
  };

  const isOptionSelected = (optionId) => {
    if (question.question_type === "SINGLE_CHOICE") {
      return selectedOptions === optionId;
    } else if (question.question_type === "MULTI_SELECT") {
      return (
        Array.isArray(selectedOptions) && selectedOptions.includes(optionId)
      );
    }
    return false;
  };

  return (
    <div className="question-container">
      <div className="question-header">
        <span className="question-counter">
          {t("question")}{" "}
          {isRTL
            ? convertToArabicNumerals(questionIndex + 1)
            : questionIndex + 1}{" "}
          {t("outOf")}{" "}
          {isRTL ? convertToArabicNumerals(totalQuestions) : totalQuestions}
        </span>
      </div>

      <div className="question-content">
        <h2 className="question-text">{question.text}</h2>

        <div className="options-container">
          {question.options
            .sort((a, b) => a.orderIndex - b.orderIndex)
            .map((option) => (
              <button
                key={option.id}
                className={`assessment-item ${
                  isOptionSelected(option.id) ? "selected" : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                <div className="assessment-info">{option.displayText}</div>
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Question;
